<template>
  <router-view/>
</template>

<style lang="scss">
@import './assets/styles/SCSS/main.scss'
</style>
